import { twMerge } from 'tailwind-merge';

import Button, { ButtonSize, ButtonVariant } from '@/components/button';
import Toggle from '@/components/toggle';
import Typography from '@/components/typography';

import { useToolbarContext } from '../provider';

export const QuickMeasureMenu = () => {
  const { clearQuickMeasure, setUseFeet, useFeet } = useToolbarContext();
  return (
    <div className="relative">
      <div
        className={twMerge(
          'overflow-hidden bg-gray-90 text-white transition-all ease-in-out',
          'min-h-[108px] w-[220px]'
        )}
      >
        <div className="h-[108px] w-[220px] p-3">
          <Typography variant="button2">Quick Measure</Typography>
          <Typography className="mt-1" variant="body2">
            Click the map to set points.
          </Typography>
          <div className="mt-2 flex h-[32px] items-center space-x-2">
            <Typography className="leading-[24px]" variant="body2">
              ft
            </Typography>
            <Toggle
              active={!useFeet}
              id="quick-measure-toggle"
              inputClassName="bg-green-50"
              setActive={(value) => setUseFeet(!value)}
            />
            <Typography className="leading-[24px]" variant="body2">
              m
            </Typography>
            <div className="flex-1" />
            <Button
              className="hover:bg-gray-100 active:bg-gray-100"
              size={ButtonSize.XS}
              variant={ButtonVariant.GHOST}
              onClick={clearQuickMeasure}
            >
              Clear
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
